import { lazy } from 'react'

export const ContributingEventsV1 = lazy(
  () => import('./v1/ContributingEventsV1'),
)
export const ContributingEventsV2 = lazy(
  () => import('./v2/ContributingEventsV2'),
)
